import { create } from 'zustand';
import { ackLeakAlarm, getLeakAlarm } from '../../../api/api';

const inflight = new Map();

const setAlarm = (set, deviceId, alarm) => {
  set((state) => ({
    alarms: { ...state.alarms, [deviceId]: alarm },
  }));
};

export const useLeakAlarmStore = create((set) => ({
  alarms: {},
  ackingId: null,

  fetchAlarm: (deviceId) => {
    if (!deviceId) return Promise.resolve();

    const pending = inflight.get(deviceId);
    if (pending) return pending;

    const request = getLeakAlarm(deviceId)
      .then((data) => {
        setAlarm(set, deviceId, data?.alarm ?? null);
      })
      .catch((err) => {
        if (err?.response?.status === 404) return;
      })
      .finally(() => {
        inflight.delete(deviceId);
      });

    inflight.set(deviceId, request);
    return request;
  },

  ackAlarm: async (deviceId) => {
    set({ ackingId: deviceId });

    try {
      const data = await ackLeakAlarm(deviceId);
      set((state) => ({
        ackingId: null,
        alarms: { ...state.alarms, [deviceId]: data?.alarm ?? null },
      }));
    } catch (err) {
      if (err?.response?.status === 404) {
        set((state) => ({
          ackingId: null,
          alarms: { ...state.alarms, [deviceId]: null },
        }));
        return;
      }

      set({ ackingId: null });
      throw err;
    }
  },
}));
